module.exports = __webpack_public_path__ + "static/media/docker.d297eb63.svg";